module.exports = "/_next/static/images/next-icon-5006815f201f6c898754c6de29645dae.svg";